import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import cardHeaderStyle from "assets/jss/material-dashboard-pro-react/components/cardHeaderStyle.jsx";

function CardHeader({ ...props }) {
  const {
    classes,
    className,
    children,
    color,
    plain,
    image,
    contact,
    signup,
    text,
    stats,
    icon,
    myColor,
    myShadow,
    ...rest
  } = props;

  // Default to primary (navy) when no special variant is set
  const resolvedColor = color !== undefined ? color
    : (plain || image || contact || signup) ? undefined
    : "primary";

  const cardHeaderClasses = classNames({
    [classes.cardHeader]: true,
    [classes[resolvedColor + "CardHeader"]]: resolvedColor !== undefined,
    [classes.cardHeaderPlain]: plain,
    [classes.cardHeaderImage]: image,
    [classes.cardHeaderContact]: contact,
    [classes.cardHeaderSignup]: signup,
    [classes.cardHeaderText]: text,
    [classes.cardHeaderStats]: stats,
    [classes.cardHeaderIcon]: icon,
    [className]: className !== undefined
  });
  return (
    <div style={{ background: myColor, boxShadow: myShadow }} className={cardHeaderClasses} {...rest}>
      {children}
    </div>
  );
}

CardHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
    "white"
  ]),
  plain: PropTypes.bool,
  image: PropTypes.bool,
  contact: PropTypes.bool,
  signup: PropTypes.bool,
  text: PropTypes.bool,
  stats: PropTypes.bool,
  icon: PropTypes.bool,
  myColor: PropTypes.string,
  myShadow: PropTypes.string
};

export default withStyles(cardHeaderStyle)(CardHeader);
